import { focusVisible } from '@space-core/styles'
import styled from 'styled-components'

import BundleCardDefault from '../default'
import type { BundleCardProps } from '../types'

import '@hotmart/cosmos/dist/styles/utilities/text/variations/green.css'

const BundleButton = styled.button`
  background: 0;
  ${focusVisible}

  &:hover {
    ._child-vertical {
      display: flex;
      background-color: var(--black);
      height: 100%;
      opacity: 0.8;
      border-radius: 0.5rem;
      align-items: end;
      transition: opacity 0.2s ease-out;
      z-index: 2;
    }
  }
`

const BundleCard = ({
  bundle,
  handleClick,
  items,
  orientation,
  containerOrientation,
  imageOrientation,
  themeMode
}: BundleCardProps) => {
  return (
    <BundleButton
      data-test='bundle-btn'
      onClick={handleClick}
      className='_border-0  _w-full _p-0 _cursor-pointer'>
      <BundleCardDefault
        bundle={bundle}
        items={items}
        orientation={orientation}
        containerOrientation={containerOrientation}
        imageOrientation={imageOrientation}
        themeMode={themeMode}
      />
    </BundleButton>
  )
}

export default BundleCard
